import api from "@/services/api";

interface PagBankStatusResponse {
  connected: boolean;
  pagbankConnect: boolean;
  accountId?: string;
  accountName?: string;
}

class GetPagBankStatus {
  execute = async () => {
    const response = await api().get(`/partner/pagbank-status`);
    return response.data as PagBankStatusResponse;
  };
}

export { GetPagBankStatus };











